import { createClient, type SupabaseClient } from '@supabase/supabase-js'

/**
 * Supabase-Client für das NEURA Performance Intranet.
 *
 * Dieses Projekt hat ein EIGENES Supabase-Projekt. Es teilt weder Datenbank
 * noch Keys mit anderen Vorhaben — siehe CLAUDE.md.
 *
 * Hier landet ausschliesslich der Publishable Key (frueher: anon key). Er ist
 * dafuer gemacht, im Browser zu stehen; die Zugriffsgrenze zieht RLS in
 * Postgres, nicht die Geheimhaltung dieses Werts. Der Service-Role-Key hat im
 * Client nichts zu suchen — alles mit VITE_-Praefix landet im Bundle.
 */

const url = import.meta.env.VITE_SUPABASE_URL
const publishableKey = import.meta.env.VITE_SUPABASE_ANON_KEY

/** Ist die Anwendung ueberhaupt konfiguriert? Die Login-Seite zeigt das an. */
export const isSupabaseConfigured = Boolean(url && publishableKey)

if (!isSupabaseConfigured && import.meta.env.DEV) {
  console.warn(
    '[NEURA] VITE_SUPABASE_URL oder VITE_SUPABASE_ANON_KEY fehlen. ' +
      '.env.example nach .env kopieren und ausfuellen.',
  )
}

export const supabase: SupabaseClient = createClient(
  url ?? 'https://placeholder.supabase.co',
  publishableKey ?? 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'neura-eng-auth',
      flowType: 'pkce',
    },
    global: {
      headers: { 'x-application-name': 'neura-engineering-intranet' },
    },
  },
)
